(function () {
  if (!window.customElements || customElements.get('purchase-media-feature-cards')) {
    return;
  }

  class PurchaseMediaFeatureCards extends HTMLElement {
    connectedCallback() {
      this.videos = Array.from(this.querySelectorAll('video'));
      this.handleVideoError = this.handleVideoError.bind(this);
      this.videos.forEach((video) => video.addEventListener('error', this.handleVideoError));

      if (this.classList.contains('purchase-media-feature-cards--motion')) {
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (prefersReducedMotion || !('IntersectionObserver' in window)) {
          this.classList.add('is-visible');
        } else {
          this.observer = new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) {
              this.classList.add('is-visible');
              this.observer.disconnect();
            }
          }, { threshold: 0.15 });
          this.observer.observe(this);
        }
      }
    }

    handleVideoError(event) {
      const media = event.currentTarget.closest('[data-media-variant]');
      if (media) {
        media.classList.add('is-video-fallback');
      }
    }

    disconnectedCallback() {
      this.videos.forEach((video) => video.removeEventListener('error', this.handleVideoError));
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }

  }

  customElements.define('purchase-media-feature-cards', PurchaseMediaFeatureCards);
})();